import { useState, useEffect } from "react";
import {
  FaChevronLeft,
  FaChevronRight,
  FaStar,
  FaMapMarkerAlt,
} from "react-icons/fa";

import "./Testimonials.css";
import testimonialsData from "../../data/testimonialsData";

const Testimonials = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === testimonialsData.length - 1 ? 0 : prev + 1,
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? testimonialsData.length - 1 : prev - 1,
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide]);

  const testimonial = testimonialsData[currentSlide];

  return (
    <section className="testimonials">
      <div className="testimonials-container">
        {/* Heading */}

        <div className="testimonials-heading">
          <span className="section-tag">TESTIMONIALS</span>

          <h2>What Our Clients Say</h2>

          <p>
            Trusted by Schools, Sports Academies, Clubs & Organizations Across
            India.
          </p>
        </div>

        {/* Main Layout */}

        <div className="testimonial-wrapper">
          {/* LEFT */}

          <div className="testimonial-image">
            <img src={testimonial.image} alt={testimonial.project} />

            <div className="project-badge">{testimonial.project}</div>

            <div className="location-badge">
              <FaMapMarkerAlt />

              {testimonial.location}
            </div>

            <div className="surface-badge">{testimonial.surface}</div>
          </div>

          {/* RIGHT */}

          <div className="testimonial-content">
            <div className="stars">
              {[...Array(testimonial.rating)].map((_, index) => (
                <FaStar key={index} />
              ))}
            </div>

            <p className="review">"{testimonial.review}"</p>

            <h3>{testimonial.name}</h3>

            <span className="designation">{testimonial.designation}</span>

            <span className="company">{testimonial.company}</span>

            {/* Bottom Controls */}

            <div className="testimonial-bottom">
              <div className="testimonial-dots">
                {testimonialsData.map((_, index) => (
                  <span
                    key={index}
                    className={currentSlide === index ? "dot active" : "dot"}
                    onClick={() => setCurrentSlide(index)}
                  />
                ))}
              </div>

              <div className="testimonial-buttons">
                <button onClick={prevSlide}>
                  <FaChevronLeft />
                </button>

                <button onClick={nextSlide}>
                  <FaChevronRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
